export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const headers: HeadersInit = { ...(init?.headers ?? {}) };

  // Session cookie is HttpOnly so we don't read/inject anything; fetch
  // just needs to include credentials.
  const res = await fetch(path, { ...(init ?? {}), headers, credentials: 'include' });
  if (!res.ok) {
    let detail = `${path} → ${res.status}`;
    try {
      const body = (await res.clone().json()) as { error?: string };
      if (body?.error) detail = body.error;
    } catch {
      // keep the default message
    }
    throw new ApiError(res.status, detail);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export const fetcher = <T>(path: string) => api<T>(path);

export function apiJson<T>(
  path: string,
  method: 'POST' | 'PUT' | 'PATCH' | 'DELETE',
  body?: unknown,
): Promise<T> {
  const init: RequestInit = { method };
  if (body !== undefined) {
    init.body = JSON.stringify(body);
    init.headers = { 'content-type': 'application/json' };
  }
  return api<T>(path, init);
}
